/**
 * @ngdoc directive
 * @name ng.directive:ngVideoReality
 * @element ANY
 */

import vrJS from 'video.js';
import 'videojs-vr';

const ngVideoReality = [() => {
    return {
        link: function ( $scope, $item, $params ) {
            let video = document.createElement('video');
            video.setAttribute('id', 'video-reality');
            video.setAttribute('class', 'video-js vjs-default-skin');
            video.setAttribute('controls', '');
            video.setAttribute('playsinline', '');

            angular.forEach($scope.service.player.sources.mp4, (item) => {
                if (item.type !== 'link') {
                    let source = document.createElement('source');
                    source.src = item.link;
                    source.type = 'video/mp4';
                    video.appendChild(source);
                }
            });

            $item[0].appendChild(video);

            let player = vrJS('video-reality');
            player.mediainfo = player.mediainfo || {};

            player.vr({projection: 'AUTO', debug: true, forceCardboard: false});
        }
    };
}];

export default ngVideoReality;
